import React from 'react';
import Component from '@vfuk/core-icon-snippet';
const IconSnippet = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default IconSnippet;
